export const getPrintTemplate = (values) => {
  const {
    unit = "",
    address = "",
    accountNumber = "",
    workshopName = "",
    productName = "",
    itemsHeader = [],
    openingBalance = { totalAmount: 0, itemAmounts: [] },
    details = [],
    totalIncurred = { totalAmount: 0, itemAmounts: [] },
    creditAccount = { accountNumber: "", amount: 0 },
    closingBalance = { totalAmount: 0, itemAmounts: [] },
    totalPages = "1",
    openingDate = "",
    reportDate = "",
    ledgerClerk = "",
    chiefAccountant = "",
    legalRepresentative = "",
    signingDay = "",
    signingMonth = "",
    signingYear = "",
  } = values;

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");

  let headersHtml = "";
  itemsHeader.forEach((header) => {
    headersHtml += `<th class="border" width="100">${header}</th>`;
  });

  let indexHeadersHtml = "";
  itemsHeader.forEach((_, idx) => {
     indexHeadersHtml += `<th class="border">${idx + 2}</th>`;
  });

  let rowsHtml = "";

  // Opening Balance Row
  rowsHtml += `
    <tr style="font-weight: bold;">
      <td class="border"></td>
      <td class="border"></td>
      <td class="border"></td>
      <td class="border px-1">Số dư đầu kỳ</td>
      <td class="border"></td>
      <td class="border text-right px-1">${fmt(openingBalance.totalAmount)}</td>
      ${(openingBalance.itemAmounts || []).map(val => `<td class="border text-right px-1">${fmt(val)}</td>`).join("")}
    </tr>
  `;

  // details
  details.forEach((item) => {
    rowsHtml += `
      <tr>
        <td class="border text-center">${item.bookingDate || ""}</td>
        <td class="border text-center">${item.documentNumber || ""}</td>
        <td class="border text-center">${item.documentDate || ""}</td>
        <td class="border px-1">${item.description || ""}</td>
        <td class="border text-center">${item.correspondingAccount || ""}</td>
        <td class="border text-right px-1 font-bold">${fmt(item.amounts?.totalAmount)}</td>
        ${(item.amounts?.itemAmounts || []).map(val => `<td class="border text-right px-1">${fmt(val)}</td>`).join("")}
      </tr>
    `;
  });

  // Total Incurred
  rowsHtml += `
    <tr style="font-weight: bold;">
      <td class="border"></td>
      <td class="border"></td>
      <td class="border"></td>
      <td class="border px-1">Cộng số phát sinh trong kỳ</td>
      <td class="border"></td>
      <td class="border text-right px-1">${fmt(totalIncurred.totalAmount)}</td>
      ${(totalIncurred.itemAmounts || []).map(val => `<td class="border text-right px-1">${fmt(val)}</td>`).join("")}
    </tr>
  `;

  // Credit Account
  rowsHtml += `
    <tr style="font-weight: bold;">
      <td class="border"></td>
      <td class="border"></td>
      <td class="border"></td>
      <td class="border px-1">Ghi Có TK: ${creditAccount.accountNumber || ""}</td>
      <td class="border"></td>
      <td class="border text-right px-1">${fmt(creditAccount.amount)}</td>
      ${itemsHeader.map(() => `<td class="border text-center">x</td>`).join("")}
    </tr>
  `;

  // Closing Balance
  rowsHtml += `
    <tr bgcolor="#FAFAFA" style="font-weight: bold;">
      <td class="border"></td>
      <td class="border"></td>
      <td class="border"></td>
      <td class="border px-1">Số dư cuối kỳ</td>
      <td class="border"></td>
      <td class="border text-right px-1" style="color: blue;">${fmt(closingBalance.totalAmount)}</td>
      ${(closingBalance.itemAmounts || []).map(val => `<td class="border text-right px-1">${fmt(val)}</td>`).join("")}
    </tr>
  `;

  return `
    <div style="font-family: 'Times New Roman', Times, serif; font-size: 13px; color: black; line-height: 1.4;">
      <table width="100%">
        <tr>
          <td width="60%" valign="top">
            <div class="font-bold">Đơn vị: <span style="font-weight: normal; border-bottom: 1px dotted black;">${unit}</span></div>
            <div class="font-bold">Địa chỉ: <span style="font-weight: normal; border-bottom: 1px dotted black;">${address}</span></div>
          </td>
          <td width="40%" align="center">
            <div class="font-bold">Mẫu số S36-DN</div>
            <div style="font-style: italic; font-size: 11px;">(Kèm theo Thông tư số 99/2025/TT-BTC <br/> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
          </td>
        </tr>
      </table>

      <div style="text-align: center; margin: 20px 0;">
        <h2 style="margin: 0; text-transform: uppercase;">SỔ CHI PHÍ SẢN XUẤT, KINH DOANH</h2>
        <div style="font-style: italic; font-size: 11px;">(Dùng cho các TK 621, 622, 623, 627, 154, 641, 642, 242, 335, 632)</div>
        
        <div style="margin-top: 15px;">- Tài khoản: <span style="border-bottom: 1px dotted black; padding: 0 20px; font-weight: bold;">${accountNumber}</span></div>
        <div style="margin-top: 5px;">- Tên phân xưởng: <span style="border-bottom: 1px dotted black; padding: 0 40px; font-weight: bold;">${workshopName}</span></div>
        <div style="margin-top: 5px;">- Tên sản phẩm, dịch vụ: <span style="border-bottom: 1px dotted black; padding: 0 60px; font-weight: bold;">${productName}</span></div>
      </div>

      <table width="100%" style="border-collapse: collapse; margin-top: 20px;">
        <thead>
          <tr>
            <th class="border" rowspan="2" width="70">Ngày, tháng ghi sổ</th>
            <th class="border" colspan="2">Chứng từ</th>
            <th class="border" rowspan="2">Diễn giải</th>
            <th class="border" rowspan="2" width="60">TK đối ứng</th>
            <th class="border" colspan="${1 + itemsHeader.length}">Ghi Nợ Tài khoản...</th>
          </tr>
          <tr>
            <th class="border" width="60">Số hiệu</th>
            <th class="border" width="60">Ngày tháng</th>
            <th class="border" width="100">Tổng số tiền</th>
            ${headersHtml}
          </tr>
          <tr bgcolor="#F0F0F0">
            <th class="border">A</th>
            <th class="border">B</th>
            <th class="border">C</th>
            <th class="border">D</th>
            <th class="border">E</th>
            <th class="border">1</th>
            ${indexHeadersHtml}
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
        </tbody>
      </table>

      <div style="margin-top: 25px;">
        <div style="margin-bottom: 5px;">- Sổ này có <span style="border-bottom: 1px dotted black; padding: 0 10px;">${totalPages}</span> trang, đánh số từ trang 01 đến trang...</div>
        <div>- Ngày mở sổ: <span style="border-bottom: 1px dotted black; padding: 0 10px;">${openingDate}</span></div>
      </div>

      <table width="100%" style="margin-top: 40px; text-align: center;">
        <tr>
          <td width="30%">
            <div class="font-bold">Người ghi sổ</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên)</div>
            <div style="margin-top: 80px;" class="font-bold">${ledgerClerk}</div>
          </td>
          <td width="30%">
            <div class="font-bold">Kế toán trưởng</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên)</div>
            <div style="margin-top: 80px;" class="font-bold">${chiefAccountant}</div>
          </td>
          <td width="40%">
            <div style="font-style: italic; font-size: 11px; margin-bottom: 5px;">Ngày ${signingDay} tháng ${signingMonth} năm ${signingYear}</div>
            <div class="font-bold">Người đại diện theo pháp luật</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên, đóng dấu)</div>
            <div style="margin-top: 80px;" class="font-bold">${legalRepresentative}</div>
          </td>
        </tr>
      </table>
    </div>

    <style>
      .border { border: 1px solid black; }
      .text-center { text-align: center; }
      .text-right { text-align: right; }
      .font-bold { font-weight: bold; }
      .px-1 { padding: 0 4px; }
    </style>
  `;
};
